import React from 'react'
import classnames from 'classnames'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import { startProCheckout } from '../../proCheckout'

const ProBadge = ({ className, uiStore, t, planId, children }) => {
  const handleActivate = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    await startProCheckout({ uiStore, t, planId })
  }

  return (
    <span
      className={classnames(className, 'pro-tag')}
      role='button'
      tabIndex={0}
      onClick={handleActivate}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleActivate(e)
        }
      }}
    >
      {children || t('GLOBAL.PRO')}
    </span>
  )
}

export default withTranslation()(inject('uiStore')(observer(ProBadge)))
